
export default {
    LOGIN: {
        GET_ORG: {
            url: (testID) => `/shared-test/init/${testID}`,
            method: "GET",
            params: []
        },
        ORG_TYPE: {
            url: () => `/orgDetails`,
            method: "GET",
            params: []
        },
        ORG_NAME:{
            url:(orgCode) =>`/v2/orgs/${orgCode}`,
            method: "GET",
            params: []
        },
        LOGIN_TYPE: {
            url: query => `/v2/org/settings/login/${query}`,
            method: "GET",
            params: []
        },
        VERIFY_ORGCODE: {
            url: orgCode => `/v2/orgs/${orgCode}`,
            method: "GET",
            params: []
        },
        GENERATE_OTP: {
            url: retry => (retry ? `/v2/otp/retry` : `/v2/otp/generate`),
            // url: () => `/v3/user/sendOTP`,
            method: "POST",
            params: []
        },
        VERIFY_OTP: {
            url: () => `/v2/users/verify`,
            method: "POST",
            params: []
        },
        REGISTER_USER: {
            url: () => `/v2/users/register`,
            method: "POST",
            params: []
        },
        APPEAR_TEST:{
            url:(testId)=>`/shared-test/appear/${testId}`,
            method: "GET",
            params:[]
        },
        GET_CMS_TOKEN:{
            url:()=>`/v3/cms/token`,
            method:"GET",
            paramS:[]
        },
        GET_STUDENT_SIDE_TOKEN: {
            url: () => `/v3/cms/token`,
            method: "GET",
            params: []
        },
        GET_TUTOR_SIDE_TOKEN: {
            url: () => `/user/wl-login/`,
            method: "GET",
            params: []
        },
        WL_REFRESH_ACCESS_TOKEN :{ 
            url:()=>"/users/refreshAccessToken",
            method: "POST",
            params: []
        },
        GET_COUNTRY_DETAILS :{
            url:(orgId)=> `/v2/org/settings/login/?orgId=${orgId}`,
            method:"GET",
            params:[]
        }
    }
};
